module.exports = __webpack_public_path__ + "static/img/icon_followed.82d1f9a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/icon_followed.png
// module id = Jy3u
// module chunks = 28